import store from "@packages/store";
import Vue from "vue";

export default {
    async load() {
        Vue.api.integrationManagement.list().then(integrations => {
            store.commit("INTEGRATION_SET_LIST", integrations);
        });
    },
    async loadIntegrationsAccessExecution() {
        Vue.api.integrationManagement.listIntegrationsAccessExecution().then(integrations => {
            store.commit("INTEGRATION_ACCESS_EXECUTION_SET_LIST", integrations);
        });
    }
};
